import React from 'react';
import cn from 'clsx';
import styles from './style.module.scss';
import DragDropItem from '@components-clean/core/drag-drop-lists-core/drag-drop-item';
import { DragDropItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import { useTranslation } from '@hooks/index';

export type DataFilterDragDropDataItem = {
    title: string;
    subtitle: string;
    id: string;
} & Exclude<DragDropItemProps['dataItem'], 'title' | 'subtitle'>;

export type DataFilterDragDropItemProps = {
    dataItem: DataFilterDragDropDataItem;
} & Exclude<DragDropItemProps, 'dataItem' | 'id' | 'label'>;

export const DataFilterDragDropItem = ({ dataItem, ...props }: DataFilterDragDropItemProps) => {
    const { t } = useTranslation();

    const renderTitle = (title?: string | null) => (
        <>
            <span>{t('label')}: </span>
            <span className={cn(styles.listboxSecondary)}>{title}</span>
        </>
    );

    const renderSubtitle = (title?: string | null) => (
        <>
            <span>{t('field')}: </span>
            <span className={cn(styles.listboxSecondary)}>{title}</span>
        </>
    );

    return (
        <DragDropItem
            {...props}
            dataItem={{
                ...dataItem,
                title: renderTitle(dataItem.title),
                subtitle: renderSubtitle(dataItem.subtitle),
            }}
        />
    );
};
